import { IApplicationState } from '../types/redux';

export const selectQueryParams = (state: IApplicationState) => state.page.queryParams;
